import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { get, set } from '@ember/object';
import Changeset from 'ember-changeset';

export default Route.extend({
  coachingService: service(),
  store: service(),

  beforeModel() {
    this.coachingService.clearSelectedIndividual();
  },

  model(params) {
    if (params.id === 'new') {
      let record = this.store.createRecord('coaching/individual');
      let changeset = new Changeset(record);
      set(changeset, 'staticInfo', [{ l: 'Name', v: 'Paul' }]);
      return {
        record,
        changeset,
      };
    } else {
      return this.store
        .find('coaching/individual', params.id)
        .then((record) => {
          let changeset = new Changeset(record);
          return {
            record,
            changeset,
          };
        });
    }
  },
});
